<template>
  <section class="fullscreen-landing-section success-page">
    <div class="overlay">
      <div class="container">
        <i class="fa fa-check-circle-o" aria-hidden="true"></i>
        <h1>{{ $t('autopurchaseform.labels.formSubmitted') }}</h1>
        <p>{{ $t('autopurchaseform.labels.requestSuccessMessage') }}</p>
        <router-link to="/">{{ $t('autopurchaseform.labels.backToHome') }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SuccessPage",
  mounted() {
    // ✅ Check if the form was actually submitted
    if (!sessionStorage.getItem("formSubmitted")) {
      console.warn("❌ Unauthorized access to success page. Redirecting...");
      this.$router.push("/"); // Redirect to home if accessed manually
    } else {
      // ✅ Remove the flag so the user can’t refresh and stay on success
      sessionStorage.removeItem("formSubmitted");
    }
  }
};
</script>

<style scoped>
.success-container {
  text-align: center;
  margin-top: 50px;
}

.success-container h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #28d2ae;
}
</style>